import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function BlogIndex() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>TankBuddy Blog - Water Tank Cleaning Tips Gurugram</title>
        <meta name="description" content="Expert tips on water tank cleaning in Gurugram from TankBuddy." />
      </Helmet>
      <Header />
      <main className="max-w-4xl mx-auto px-4 py-20">
        <a href="/" className="text-sky text-sm">Back to Home</a>
        <h1 className="font-heading font-bold text-4xl text-navy mt-6 mb-4">Water Tank Cleaning Tips and Guides</h1>
        <p className="text-slate-500 mb-10">Expert advice for Gurugram homeowners.</p>
        <div className="space-y-4">
          <a href="/blog/how-often-clean-water-tank-gurugram" className="block border border-slate-200 rounded-xl p-6 hover:border-sky/50">
            <span className="text-xs text-sky font-medium">Tank Maintenance</span>
            <h2 className="font-bold text-navy mt-1">How Often Should You Clean Your Water Tank in Gurugram?</h2>
            <p className="text-slate-500 text-sm mt-1">Experts recommend cleaning every 6 months. Find out why.</p>
          </a>
          <a href="/blog/signs-water-tank-needs-cleaning" className="block border border-slate-200 rounded-xl p-6 hover:border-sky/50">
            <span className="text-xs text-sky font-medium">Health and Safety</span>
            <h2 className="font-bold text-navy mt-1">5 Signs Your Water Tank Needs Immediate Cleaning</h2>
            <p className="text-slate-500 text-sm mt-1">Warning signs you should never ignore.</p>
          </a>
          <a href="/blog/overhead-vs-underground-tank-cleaning" className="block border border-slate-200 rounded-xl p-6 hover:border-sky/50">
            <span className="text-xs text-sky font-medium">Expert Guide</span>
            <h2 className="font-bold text-navy mt-1">Overhead vs Underground Tank Cleaning</h2>
            <p className="text-slate-500 text-sm mt-1">Different equipment and protocols for each type.</p>
          </a>
          <a href="/blog/waterborne-diseases-dirty-tanks-gurugram" className="block border border-slate-200 rounded-xl p-6 hover:border-sky/50">
            <span className="text-xs text-sky font-medium">Health and Safety</span>
            <h2 className="font-bold text-navy mt-1">Water-Borne Diseases from Dirty Tanks in Gurugram</h2>
            <p className="text-slate-500 text-sm mt-1">The number one cause of waterborne diseases in Gurugram.</p>
          </a>
          <a href="/blog/diy-vs-professional-tank-cleaning-gurugram" className="block border border-slate-200 rounded-xl p-6 hover:border-sky/50">
            <span className="text-xs text-sky font-medium">Cost Guide</span>
            <h2 className="font-bold text-navy mt-1">DIY vs Professional Tank Cleaning - Cost Comparison</h2>
            <p className="text-slate-500 text-sm mt-1">Is DIY actually cheaper? We break down the real costs.</p>
          </a>
        </div>
      </main>
      <Footer />
    </div>
  );
}
